export enum InvestigationReportTypes {
	incidentReport = 'incidentReport',
	scissorLiftReportExport = 'scissorLiftReportExport',
	dailyRoute = 'dailyRoute',
	workersTimesheet = 'workersTimesheet',
	observeLocation = 'observeLocation',
	projectOverview = 'projectOverview',
	contractorAnalysis = 'contractorAnalysis',
}
